/*
 * @Author: Latte
 * @Date: 2021-08-03 12:09:15
 * @LAstEditors: Latte
 * @LastEditTime: 2021-08-06 09:11:24
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\diagnosisManagement\diagnosticTeamManagement.js
 */

import request from '@/utils/request'
import config from '@/utils/config'

/**
 * @description: 创建管理团队
 * @param {*} data
 * @return {*}
 */
export function addDiagnosticTeam(data) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/add',
    method: 'post',
    data
  })
}

/**
 * @description: 通过团队创建申请
 * @param {*} data
 * @return {*}
 */
export function allowTeamApplication(data) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/audit',
    method: 'patch',
    data
  })
}

/**
 * @description: 拒绝团队创建申请
 * @param {*} data
 * @return {*}
 */
 export function refuseTeamApplication(data) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/audit',
    method: 'patch',
    data
  })
}

/**
 * @description: 获取单个团队详情
 * @param {*} params
 * @return {*}
 */
export function getTeamDetail(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/detail',
    method: 'get',
    params
  })
}

/**
 * @description: 获取所有团队信息
 * @param {*} params
 * @return {*}
 */
export function getAllTeamList(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/list',
    method: 'get',
    params
  })
}

/**
 * @description: 更新团队信息
 * @param {*} data
 * @return {*}
 */
export function updateTeamDetail(data) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/update',
    method: 'patch',
    data
  })
}